import { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useTranslation } from 'react-i18next';

const TestUserPopup = ({ open, cancel, submit }) => {
    const [inputValue, setInputValue] = useState('');
    const { t } = useTranslation();

    const handleInputChange = (event) => {
        const val = event.target.value;
        setInputValue(val);
    };
    return (
        <Dialog
            open={open}
            onClose={cancel}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">{t('')}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t('dialog.registerTestUserExplanation')}
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    variant="outlined"
                    id="name"
                    label="Naam"
                    fullWidth
                    value={inputValue}
                    onChange={handleInputChange}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={cancel} color="primary">
                    {t('buttons.cancel')}
                </Button>
                <Button
                    onClick={() => {
                        submit(inputValue);
                    }}
                    color="primary"
                    disabled={!inputValue}
                >
                    {t('buttons.register')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TestUserPopup;
